<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ $t('system.system') }} {{ item.id }}</h3>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.alias') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.alias" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.whetherCollected') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-checkbox v-model="item.collecting" dense class="mt-0 pt-0 pb-2"></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.database.name') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.database.name" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name empty"></div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.database.type') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="item.database.type" :items="dbmsTypes" item-text="name" item-value="name" class="item-select w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.version') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.database.version" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.host') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.database.host" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.port') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.database.port" type="number" min="1" max="65535" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.username') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.database.username" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.password') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-text-field v-model="item.database.password" class="w-auto" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" outlined dense
                ></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3" v-show="item.liveCaches.length > 0 ? true : false">
          <v-col cols="12">
            <v-card flat class="dialog-form" :class="classContents">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('system.description') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <v-data-table
                      ref="list"
                      dense
                      :headers="headers"
                      :items="item.liveCaches"
                      item-key="name"
                      class="elevation-1"
                      hide-default-footer>
                      <template v-slot:item.active="{ item }">
                        <v-simple-checkbox :ripple="false" v-model="item.active"></v-simple-checkbox>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="save" :disabled="disabledSave">{{ $t('common.save') }}</v-btn>
        <v-btn small color="primary" @click="cancel">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from '@/api/common/instances';
import editable from './mixins/editable';

export default {
  mixins: [editable],
  data() {
    return {
      showPassword: false,
      dbmsTypes: [],
      headers: [
        { text: this.$t('system.liveCache.connectionName'), value: 'connectionName', sortable: false },
        { text: this.$t('system.liveCache.active'), value: 'active', sortable: false },
      ],
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    async onShow() {
      ({ data: this.dbmsTypes } = await api.get('/dbmstypes'));
    },
  },
};
</script>

<style scoped>
.empty {
  height: 50px;
}
</style>
<style>
.item-select .v-input__slot {
  height: 24px;
}
.v-input__append-inner {
  margin-top: 2px !important;
}
.v-input__prepend-inner {
  margin-top: 2px !important;
}
</style>
